/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useState } from 'react';
import { AlertDialog } from '@components/design-system';
import { Info } from './info';
import { Labels } from './labels';
import { Layout } from './layout';
import { Market } from './market';
import { Theme } from './theme';
import { Welcome } from './welcome';

const STEPS = [Welcome, Layout, Info, Market, Labels, Theme];

export interface IUserOnboarding {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  masonry?: boolean;
  info?: boolean;
  market?: boolean;
  labels?: boolean;
}

export const UserOnboarding: FC<IUserOnboarding> = ({
  open,
  onOpenChange,
  masonry = true,
  info = false,
  market = false,
  labels = false,
}) => {
  const [values, setValues] = useState({ masonry, info, market, labels });
  const [step, setStep] = useState(0);

  const handleChange = (key: string, value: any) => {
    setValues((prevValues) => ({
      ...prevValues,
      [key]: value,
    }));
  };

  const handleStep = (increment: number) => {
    const nextStep = step + increment;
    if (nextStep < STEPS.length) {
      setStep(nextStep);
    } else if (onOpenChange) {
      onOpenChange(false);
    }
  };

  return (
    <AlertDialog
      open={open}
      onOpenChange={onOpenChange}
      fill
      opaque
      /* only available if Terms are enabled large={step === 5} */
      canClose={false}
    >
      {STEPS.map((Component, index) => {
        if (step === index) {
          return (
            <Component key={`slide-${index}`} values={values} handleChange={handleChange} handleStep={handleStep} />
          );
        }
        return null;
      })}
    </AlertDialog>
  );
};
